import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d541a586"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "enterprise",
  style: {"border":"none"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、企业法定代表人姓名如为中国大陆公民，请输入身份证姓名。", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、企业法定代表人如为中国香港公民及台湾同胞，请输入来往大陆通行证姓名。", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、企业法定代表人如为外籍人士，请输入护照姓名。", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、企业管理员姓名如为中国大陆公民，请输入身份证姓名。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、企业管理员如为中国香港公民及台湾同胞，请输入来往大陆通行证姓名。", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、企业管理员如为外籍人士，请输入护照姓名。", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、企业法定代表人如为中国大陆公民，请输入身份证号码。", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、企业法定代表人如为中国香港公民及台湾同胞，请输入来往大陆通行证号码。", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、企业法定代表人如为外籍人士，请输入护照号码。", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、企业管理员如为中国大陆公民，请输入身份证号码。", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、企业管理员如为中国香港公民及台湾同胞，请输入来往大陆通行证号码。", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、企业管理员如为外籍人士，请输入护照号码。", -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "ant-upload-text" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#628BE2"} }, "点击上传", -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["src"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 1,
  class: "updown"
}
const _hoisted_26 = { class: "updown-txt" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请下载模版填写信息并上传", -1))
const _hoisted_28 = { class: "updown-box" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#628BE2"} }, "上传文件", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#628BE2"} }, "下载模版", -1))
const _hoisted_31 = ["src"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "ant-upload-text" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#628BE2"} }, "点击上传", -1))
const _hoisted_39 = ["src"]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "ant-upload-text" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#628BE2"} }, "点击上传", -1))
const _hoisted_47 = ["src"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "ant-upload-text" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#628BE2"} }, "点击上传", -1))
const _hoisted_55 = ["src"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "ant-upload-text" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#628BE2"} }, "点击上传", -1))
const _hoisted_63 = { class: "enterprise" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-border-bottom" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h2-blue-underline" }, "企业对公账户信息")
], -1))
const _hoisted_65 = {
  key: 0,
  class: "mark"
}
const _hoisted_66 = ["src"]
const _hoisted_67 = {
  key: 0,
  class: "mark-box"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","font-size":"18px","color":"#fff"} }, "处理中，请稍等...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_info_circle_outlined = _resolveComponent("info-circle-outlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_cloud_upload_outlined = _resolveComponent("cloud-upload-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_cloud_download_outlined = _resolveComponent("cloud-download-outlined")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: "企业实名认证类型:",
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.companyPrincipalType), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.modelRef.companyPrincipalType,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.companyPrincipalType) = $event)),
                        disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                        onChange: _ctx.handleChangeType
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("企业代表法人")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode("企业授权代理人")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "disabled", "onChange"])
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { style: {"position":"relative","top":"-15px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 3 }),
              _createVNode(_component_a_col, {
                span: 16,
                style: {"color":"#AAAAAA","position":"relative","left":"-6px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("温馨提示：目前不支持企业实名认证类型的修改，选择不同的类型需要上传不同的客户信息，请谨慎选择。")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: _ctx.t('page.personal.center.compontent.enterprise.email'),
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.email), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        style: {"width":"92%"},
                        disabled: "",
                        value: _ctx.modelRef.email,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.email) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 16, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: _ctx.t('page.personal.center.compontent.enterprise.enterpriseName'),
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.enterpriseName), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        style: {"width":"92%"},
                        disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                        value: _ctx.modelRef.enterpriseName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.enterpriseName) = $event)),
                        placeholder: "请输入与营业执照相符的企业名称"
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  }, 16, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    style: {"position":"relative"},
                    label: _ctx.t('page.personal.center.compontent.enterprise.representative'),
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.representativeName), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { gutter: 10 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 22 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                                value: _ctx.modelRef.representativeName,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelRef.representativeName) = $event)),
                                placeholder: "请输入与营业执照相符的法人姓名"
                              }, null, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          }),
                          (_ctx.modelRef.companyPrincipalType == 1)
                            ? (_openBlock(), _createBlock(_component_a_col, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_popover, { placement: "topLeft" }, {
                                    content: _withCtx(() => [
                                      _hoisted_2,
                                      _hoisted_3,
                                      _hoisted_4
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_info_circle_outlined, { style: {"color":"#6ca0cb"} })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 16, ["label"])
                ]),
                _: 1
              }),
              (_ctx.modelRef.companyPrincipalType == 1)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({
                        label: "法定代表人手机号码",
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }, _ctx.validateInfos.legalMobile), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            style: {"width":"92%"},
                            disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                            value: _ctx.modelRef.legalMobile,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelRef.legalMobile) = $event)),
                            placeholder: "请输入法定代表人实名注册的大陆手机号码"
                          }, null, 8, ["disabled", "value"])
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.modelRef.companyPrincipalType == 2)
            ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({
                        label: "企业管理员姓名：",
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }, _ctx.validateInfos.agentName), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { gutter: 10 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 22 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                                    value: _ctx.modelRef.agentName,
                                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelRef.agentName) = $event)),
                                    placeholder: "请输入与企业管理员证件名称相符的姓名"
                                  }, null, 8, ["disabled", "value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_popover, { placement: "topLeft" }, {
                                    content: _withCtx(() => [
                                      _hoisted_5,
                                      _hoisted_6,
                                      _hoisted_7
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_info_circle_outlined, { style: {"color":"#6ca0cb"} })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({
                        label: "企业管理员手机号码",
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }, _ctx.validateInfos.agentMobile), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            style: {"width":"92%"},
                            disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                            value: _ctx.modelRef.agentMobile,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelRef.agentMobile) = $event)),
                            placeholder: "请输入企业管理员实名注册的大陆手机号码"
                          }, null, 8, ["disabled", "value"])
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.modelRef.companyPrincipalType == 1)
            ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({
                        label: "法定代表人证件号：",
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }, _ctx.validateInfos.legalId), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { gutter: 10 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 22 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                                    value: _ctx.modelRef.legalId,
                                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelRef.legalId) = $event)),
                                    placeholder: "请输入与法定代表人证件相符的证件号"
                                  }, null, 8, ["disabled", "value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_popover, { placement: "topLeft" }, {
                                    content: _withCtx(() => [
                                      _hoisted_8,
                                      _hoisted_9,
                                      _hoisted_10
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_info_circle_outlined, { style: {"color":"#6ca0cb"} })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({
                        label: "法人证件有效期",
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }, _ctx.validateInfos.legalTime), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { gutter: 10 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_range_picker, {
                                    style: {"width":"100%"},
                                    "value-format": "YYYY-MM-DD",
                                    disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                                    getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                                    value: _ctx.modelRef.legalTime,
                                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelRef.legalTime) = $event))
                                  }, null, 8, ["disabled", "getPopupContainer", "value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 8 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, _mergeProps({ style: {"margin-bottom":"0"} }, _ctx.validateInfos.legalIsForever), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_checkbox, {
                                        checked: _ctx.modelRef.legalIsForever,
                                        "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelRef.legalIsForever) = $event)),
                                        name: 'legalIsForever',
                                        onChange: _ctx.handleChangeForever
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("长期有效")
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "onChange"])
                                    ]),
                                    _: 1
                                  }, 16)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.modelRef.companyPrincipalType == 2)
            ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({
                        label: "企业管理人证件号：",
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }, _ctx.validateInfos.agentId), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { gutter: 10 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 22 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                                    value: _ctx.modelRef.agentId,
                                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelRef.agentId) = $event)),
                                    placeholder: "请输入与企业管理人证件相符的证件号"
                                  }, null, 8, ["disabled", "value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_popover, { placement: "topLeft" }, {
                                    content: _withCtx(() => [
                                      _hoisted_11,
                                      _hoisted_12,
                                      _hoisted_13
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_info_circle_outlined, { style: {"color":"#6ca0cb"} })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.modelRef.companyPrincipalType == 2)
            ? (_openBlock(), _createBlock(_component_a_row, { key: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({
                        label: "企业管理人证件有效期",
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }, _ctx.validateInfos.agentTime), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { gutter: 10 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_range_picker, {
                                    style: {"width":"100%"},
                                    "value-format": "YYYY-MM-DD",
                                    disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                                    getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                                    value: _ctx.modelRef.agentTime,
                                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modelRef.agentTime) = $event))
                                  }, null, 8, ["disabled", "getPopupContainer", "value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 8 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, _mergeProps({ style: {"margin-bottom":"0"} }, _ctx.validateInfos.isForever), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_checkbox, {
                                        checked: _ctx.modelRef.agentIsForever,
                                        "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modelRef.agentIsForever) = $event)),
                                        name: 'agentIsForever',
                                        onChange: _ctx.handleChangeForever
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("长期有效")
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "onChange"])
                                    ]),
                                    _: 1
                                  }, 16)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: _ctx.t('page.personal.center.compontent.enterprise.address'),
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.contactAddress), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_cascader, {
                        style: {"width":"92%"},
                        allowClear: "",
                        disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                        value: _ctx.modelRef.contactAddress,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modelRef.contactAddress) = $event)),
                        getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                        options: _ctx.arealist,
                        placeholder: "请选择联系地址"
                      }, null, 8, ["disabled", "value", "getPopupContainer", "options"])
                    ]),
                    _: 1
                  }, 16, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: _ctx.t('page.personal.center.compontent.enterprise.addressMod'),
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.detailedAddress), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        style: {"width":"92%"},
                        disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                        value: _ctx.modelRef.detailedAddress,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modelRef.detailedAddress) = $event)),
                        placeholder: "请输入正确的详细地址不超过200个字符"
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  }, 16, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: _ctx.t('page.personal.center.compontent.enterprise.creditCode'),
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.creditCode), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        style: {"width":"92%"},
                        disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                        value: _ctx.modelRef.creditCode,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modelRef.creditCode) = $event)),
                        placeholder: "请输入与营业执照相符的社会信用代码"
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  }, 16, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: _ctx.t('page.personal.center.compontent.enterprise.validity'),
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.validitytime), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { gutter: 10 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_range_picker, {
                                style: {"width":"100%"},
                                "value-format": "YYYY-MM-DD",
                                disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                                getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                                value: _ctx.modelRef.validitytime,
                                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modelRef.validitytime) = $event))
                              }, null, 8, ["disabled", "getPopupContainer", "value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, _mergeProps({ style: {"margin-bottom":"0"} }, _ctx.validateInfos.isForever), {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _ctx.modelRef.isForever,
                                    "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.modelRef.isForever) = $event)),
                                    name: 'isForever',
                                    onChange: _ctx.handleChangeForever
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("长期有效")
                                    ]),
                                    _: 1
                                  }, 8, ["checked", "onChange"])
                                ]),
                                _: 1
                              }, 16)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 16, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: _ctx.t('page.personal.center.compontent.enterprise.businessLicense')
                  }, _ctx.validateInfos.licenseAnnex, {
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_upload, {
                        "list-type": "picture-card",
                        disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                        "before-upload": _ctx.beforeUpload,
                        "show-upload-list": false,
                        "v-model:value": _ctx.modelRef.licenseAnnex,
                        customRequest: _ctx.handleUpload1
                      }, {
                        default: _withCtx(() => [
                          (_ctx.imageUrl.imgurl1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "img",
                                src: _ctx.imageUrl.imgurl1,
                                alt: "avatar"
                              }, null, 8, _hoisted_14))
                            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                (_ctx.loadingType.loading1)
                                  ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_16, [
                                  _createTextVNode(" 请上传公司营业执照扫描件"),
                                  _hoisted_17,
                                  _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.size')), 1),
                                  _hoisted_18,
                                  _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.support')) + "：JPG,PNG ", 1),
                                  _hoisted_19,
                                  _hoisted_20,
                                  _createVNode(_component_cloud_upload_outlined, { style: {"font-size":"28px","color":"#302185"} }),
                                  _hoisted_21
                                ])
                              ]))
                        ]),
                        _: 1
                      }, 8, ["disabled", "before-upload", "v-model:value", "customRequest"])
                    ]),
                    _: 1
                  }, 16, ["label"])
                ]),
                _: 1
              }),
              (_ctx.modelRef.companyPrincipalType == 2)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({ label: "企业认证申请表:" }, _ctx.validateInfos.enterpriseCertAnnex, {
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }), {
                        default: _withCtx(() => [
                          (_ctx.imageUrl.imgurl2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createVNode(_component_a_upload, {
                                  "list-type": "picture-card",
                                  "before-upload": _ctx.beforeUpload,
                                  disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                                  "show-upload-list": false,
                                  "v-model:value": _ctx.modelRef.enterpriseCertAnnex,
                                  customRequest: _ctx.handleUpload2
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.imageUrl.imgurl2)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "img",
                                          src: _ctx.imageUrl.imgurl2,
                                          alt: "avatar"
                                        }, null, 8, _hoisted_23))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                          (_ctx.loadingType.loading2)
                                            ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                            : _createCommentVNode("", true)
                                        ]))
                                  ]),
                                  _: 1
                                }, 8, ["before-upload", "disabled", "v-model:value", "customRequest"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("span", _hoisted_26, [
                                  (_ctx.loadingType.loading2)
                                    ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                    : _createCommentVNode("", true),
                                  _hoisted_27,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.size')), 1),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.support')) + "：JPG,PNG", 1)
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_a_upload, {
                                    "before-upload": _ctx.beforeUpload,
                                    "show-upload-list": false,
                                    "v-model:value": _ctx.modelRef.enterpriseCertAnnex,
                                    customRequest: _ctx.handleUpload2
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", null, [
                                        _createVNode(_component_cloud_upload_outlined, { style: {"font-size":"28px","color":"#302185"} }),
                                        _hoisted_29
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["before-upload", "v-model:value", "customRequest"]),
                                  _createElementVNode("a", {
                                    style: {"margin-left":"20px"},
                                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleDownFile && _ctx.handleDownFile(...args)))
                                  }, [
                                    _createVNode(_component_cloud_download_outlined, { style: {"font-size":"28px","color":"#302185"} }),
                                    _hoisted_30
                                  ])
                                ])
                              ]))
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.modelRef.companyPrincipalType == 1)
            ? (_openBlock(), _createBlock(_component_a_row, { key: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({ label: "法定代表人证件照正面:" }, _ctx.validateInfos.legalIdAnnex1, {
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_upload, {
                            "list-type": "picture-card",
                            disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                            "before-upload": _ctx.beforeUpload,
                            "show-upload-list": false,
                            "v-model:value": _ctx.modelRef.legalIdAnnex1,
                            customRequest: _ctx.handleUpload3
                          }, {
                            default: _withCtx(() => [
                              (_ctx.imageUrl.imgurl3)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "img",
                                    src: _ctx.imageUrl.imgurl3,
                                    alt: "avatar"
                                  }, null, 8, _hoisted_31))
                                : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    (_ctx.loadingType.loading3)
                                      ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_33, [
                                      _createTextVNode(" 请上传法定代表人证件照正面"),
                                      _hoisted_34,
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.size')), 1),
                                      _hoisted_35,
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.support')) + "：JPG,PNG ", 1),
                                      _hoisted_36,
                                      _hoisted_37,
                                      _createVNode(_component_cloud_upload_outlined, { style: {"font-size":"28px","color":"#302185"} }),
                                      _hoisted_38
                                    ])
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["disabled", "before-upload", "v-model:value", "customRequest"])
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({ label: "法定代表人证件照反面:" }, _ctx.validateInfos.legalIdAnnex2, {
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_upload, {
                            "list-type": "picture-card",
                            disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                            "before-upload": _ctx.beforeUpload,
                            "show-upload-list": false,
                            "v-model:value": _ctx.modelRef.legalIdAnnex2,
                            customRequest: _ctx.handleUpload4
                          }, {
                            default: _withCtx(() => [
                              (_ctx.imageUrl.imgurl4)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "img",
                                    src: _ctx.imageUrl.imgurl4,
                                    alt: "avatar"
                                  }, null, 8, _hoisted_39))
                                : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    (_ctx.loadingType.loading4)
                                      ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_41, [
                                      _createTextVNode(" 请上传法定代表人证件照反面"),
                                      _hoisted_42,
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.size')), 1),
                                      _hoisted_43,
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.support')) + "：JPG,PNG ", 1),
                                      _hoisted_44,
                                      _hoisted_45,
                                      _createVNode(_component_cloud_upload_outlined, { style: {"font-size":"28px","color":"#302185"} }),
                                      _hoisted_46
                                    ])
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["disabled", "before-upload", "v-model:value", "customRequest"])
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_a_row, { key: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({ label: "企业管理人证件头像面:" }, _ctx.validateInfos.agentIdAnnex1, {
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_upload, {
                            "list-type": "picture-card",
                            disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                            "before-upload": _ctx.beforeUpload,
                            "show-upload-list": false,
                            "v-model:value": _ctx.modelRef.agentIdAnnex1,
                            customRequest: _ctx.handleUpload5
                          }, {
                            default: _withCtx(() => [
                              (_ctx.imageUrl.imgurl5)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "img",
                                    src: _ctx.imageUrl.imgurl5,
                                    alt: "avatar"
                                  }, null, 8, _hoisted_47))
                                : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    (_ctx.loadingType.loading5)
                                      ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_49, [
                                      _createTextVNode(" 请上传企业管理人证件头像面"),
                                      _hoisted_50,
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.size')), 1),
                                      _hoisted_51,
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.support')) + "：JPG.PNG ", 1),
                                      _hoisted_52,
                                      _hoisted_53,
                                      _createVNode(_component_cloud_upload_outlined, { style: {"font-size":"28px","color":"#302185"} }),
                                      _hoisted_54
                                    ])
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["disabled", "before-upload", "v-model:value", "customRequest"])
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, _mergeProps({ label: "企业管理人证件照国徽面:" }, _ctx.validateInfos.agentIdAnnex2, {
                        labelCol: {span: 8},
                        wrapperCol: {span: 16}
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_a_upload, {
                            "list-type": "picture-card",
                            disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                            "before-upload": _ctx.beforeUpload,
                            "show-upload-list": false,
                            "v-model:value": _ctx.modelRef.agentIdAnnex2,
                            customRequest: _ctx.handleUpload6
                          }, {
                            default: _withCtx(() => [
                              (_ctx.imageUrl.imgurl6)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "img",
                                    src: _ctx.imageUrl.imgurl6,
                                    alt: "avatar"
                                  }, null, 8, _hoisted_55))
                                : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    (_ctx.loadingType.loading6)
                                      ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_57, [
                                      _createTextVNode(" 请上传企业管理人证件照国徽面"),
                                      _hoisted_58,
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.size')), 1),
                                      _hoisted_59,
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.support')) + "：JPG.PNG ", 1),
                                      _hoisted_60,
                                      _hoisted_61,
                                      _createVNode(_component_cloud_upload_outlined, { style: {"font-size":"28px","color":"#302185"} }),
                                      _hoisted_62
                                    ])
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["disabled", "before-upload", "v-model:value", "customRequest"])
                        ]),
                        _: 1
                      }, 16)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_63, [
      _createVNode(_component_a_card, null, {
        default: _withCtx(() => [
          _hoisted_64,
          _createVNode(_component_a_row, {
            style: {"margin-top":"15px","display":"flex","align-items":"baseline","padding":"0 1%"},
            gutter: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: "对公银行账号:",
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.bankId), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                        oninput: "value=value.replace(/[^\\d]/g,'')",
                        value: _ctx.modelRef.bankId,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.modelRef.bankId) = $event)),
                        placeholder: "请输入银行账号"
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: "开户银行:",
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.bankName), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                        value: _ctx.modelRef.bankName,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modelRef.bankName) = $event)),
                        getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                        "filter-option": _ctx.filterOption,
                        placeholder: "请选择开户银行",
                        "show-search": ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banklist, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.id,
                              value: item.name
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["disabled", "value", "getPopupContainer", "filter-option"])
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: "开户银行支行:",
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.subbranchName), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                        value: _ctx.modelRef.subbranchName,
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modelRef.subbranchName) = $event)),
                        placeholder: "请输入开户银行支行"
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps({
                    label: "开户行所在省市",
                    labelCol: {span: 8},
                    wrapperCol: {span: 16}
                  }, _ctx.validateInfos.bankDepositRegion), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_cascader, {
                        allowClear: "",
                        disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                        value: _ctx.modelRef.bankDepositRegion,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modelRef.bankDepositRegion) = $event)),
                        getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                        options: _ctx.arealist,
                        "show-search": { arealist: _ctx.arealist },
                        placeholder: _ctx.t('page.personal.center.compontent.enterprise.select')
                      }, null, 8, ["disabled", "value", "getPopupContainer", "options", "show-search", "placeholder"])
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { style: {"display":"flex","justify-content":"center","padding":"30px 0"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _ctx.handleSubmit,
                    disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.submit')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]),
                  _createVNode(_component_a_button, {
                    onClick: _ctx.resetFields,
                    disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.enterprise.reset')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]),
                  (_ctx.certStatus === 2)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.fddModal('two')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("认证")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.loadingM)
        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
            _createVNode(_component_a_spin)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        title: "法大大认证",
        width: "80%",
        visible: _ctx.visible,
        "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.visible) = $event)),
        footer: null,
        maskClosable: false,
        onCancel: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("iframe", {
            src: _ctx.fddurl,
            frameborder: "0",
            class: "iframe"
          }, null, 8, _hoisted_66)
        ]),
        _: 1
      }, 8, ["visible", "onCancel"])
    ]),
    (_ctx.isMark)
      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
          _createVNode(_component_a_spin),
          _hoisted_68
        ]))
      : _createCommentVNode("", true)
  ], 64))
}